var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"letter_circle",style:(_vm.styleObject)},[_vm._v(" "+_vm._s(_vm.avatar.getLetter())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }